import { FC } from 'react'
import { twMerge } from '@lib/tailwind-merge'

interface Props {
  contents: string
  className?: string
  // Renders a "+1" indicator matching the TimeWidget, for times interpreted
  // as falling on the day after the time card date.
  nextDay?: boolean
}

export const Display: FC<Props> = (props: Props) => (
  <div className="flex flex-row items-baseline">
    <div
      className={twMerge(
        'px-2 text-sm leading-none select-none text-neutral-900',
        props.className,
      )}
    >
      {props.contents}
    </div>
    {props.nextDay && props.contents !== '' && (
      <span className="pr-2 text-neutral-400 text-xs font-semibold select-none">
        +1
      </span>
    )}
  </div>
)
